import { FC } from "react";
import { HStack, Stack, Text } from "@chakra-ui/react";

import {
  MainPagePaymentScheduleAddPaymentButton,
} from "./MainPagePaymentScheduleAddPaymentButton";
import { MainPagePaymentScheduleCommission } from "./MainPagePaymentScheduleCommission";
import { formatPriceWithoutZeros } from "../../../../../utils";

interface Props {
  overdue: string;
}

export const MainPagePaymentScheduleOverdue: FC<Props> = ({ overdue }) => {
  const overdueWithCurrency = formatPriceWithoutZeros(Number(overdue));

  return (
    <Stack spacing={0} mt="3px">
      <HStack justifyContent="space-between" mb="1px">
        <Text variant="red" fontFamily="Normalidad Medium Var" fontSize="20px">
          {overdueWithCurrency}
        </Text>

        <Text variant="red" px="8px" bg="red.25" borderRadius="20px" fontSize="10px" lineHeight="23px">
          Просрочено
        </Text>
      </HStack>

      <MainPagePaymentScheduleCommission paymentAmount={overdue} />

      <MainPagePaymentScheduleAddPaymentButton />
    </Stack>
  );
};
